import script from "./Pre-Engagement-Questionnaire-Step5.vue?vue&type=script&setup=true&lang=js"
export * from "./Pre-Engagement-Questionnaire-Step5.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__